import { useCompany } from "@/lib/company";
import { useLang } from "@/lib/i18n";

export default function LegalNotice() {
  const { company } = useCompany();
  const { t } = useLang();
  if (!company) return <div className="p-12">{t("common.loading")}</div>;
  return (
    <div className="max-w-3xl mx-auto px-6 py-12" data-testid="legal-page">
      <span className="label-uppercase text-xs text-[#C85A32]">{t("legal.info")}</span>
      <h1 className="heading font-extrabold text-4xl lg:text-5xl mt-2 text-[#111812]">{t("legal.title")}</h1>

      <section className="mt-10 space-y-4 text-[15px] leading-relaxed">
        <h2 className="heading font-bold text-xl">{t("legal.editor")}</h2>
        <div className="flex items-center gap-4 p-4 bg-[#F5F5F0] rounded-lg" data-testid="legal-editor-block">
          <img src="https://customer-assets-4nw71qhi.emergentagent.net/job_sukana-launch/artifacts/s0zrb57v_LOGO%20GNL%20SEC.jpg" alt="GNL Services et Consulting" className="h-16 w-16 object-contain"/>
          <div>
            <p className="heading font-extrabold text-lg" data-testid="legal-name">{company.name}</p>
            <p className="text-xs text-[#4B5563]">{company.legal_form}</p>
          </div>
        </div>
        <p>
          {t("legal.edited_by_pre")} <strong>SUKANACOOP</strong> {t("legal.edited_by_mid")} <strong>{company.name}</strong>.
        </p>
        <ul className="space-y-2 text-[#111812]">
          <li><span className="text-[#4B5563] w-40 inline-block">{t("legal.legal_form")}</span> {company.legal_form}</li>
          <li><span className="text-[#4B5563] w-40 inline-block">{t("legal.rccm")}</span> <span className="font-mono" data-testid="legal-rccm">{company.rccm}</span></li>
          <li><span className="text-[#4B5563] w-40 inline-block">{t("legal.tax_id")}</span> <span className="font-mono">{company.tax_id}</span></li>
          <li><span className="text-[#4B5563] w-40 inline-block">{t("legal.hq")}</span> {company.address}</li>
          <li><span className="text-[#4B5563] w-40 inline-block">{t("legal.phone")}</span> <a href={`tel:${company.phone}`} className="text-[#1A3322] underline">{company.phone}</a></li>
          <li><span className="text-[#4B5563] w-40 inline-block">{t("legal.email")}</span> <a href={`mailto:${company.email}`} className="text-[#1A3322] underline">{company.email}</a></li>
          {company.manager && <li><span className="text-[#4B5563] w-40 inline-block">{t("legal.manager")}</span> {company.manager}</li>}
        </ul>

        <h2 className="heading font-bold text-xl mt-8">{t("legal.purpose")}</h2>
        <p>{t("legal.purpose_desc_pre")} {company.name}.</p>

        <h2 className="heading font-bold text-xl mt-8">{t("legal.hosting")}</h2>
        <p>{t("legal.hosting_desc")}</p>

        <h2 className="heading font-bold text-xl mt-8">{t("legal.payments")}</h2>
        <p>{t("legal.payments_desc_pre")} <strong>{t("legal.pawapay")}</strong> {t("legal.payments_desc_mid")} <strong>{t("legal.bank_transfer")}</strong> {t("legal.payments_desc_end")} {company.name}. {t("legal.payments_invoices_pre")} <strong>{company.name}</strong>.</p>

        <h2 className="heading font-bold text-xl mt-8">{t("legal.contact")}</h2>
        <p>{t("legal.contact_desc_pre")} <a href={`mailto:${company.email}`} className="text-[#1A3322] underline">{company.email}</a> {t("legal.contact_desc_or")} {company.phone}.</p>
      </section>
    </div>
  );
}
